import { render } from "./LayoutPublico.vue?vue&type=template&id=5e9f3be0"
import script from "./LayoutPublico.vue?vue&type=script&lang=js"
export * from "./LayoutPublico.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wServer\\app-pagos-elroble\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__